import { createState, useState } from '@hookstate/core';

const initialState = createState(null);

const useAuth = () => {
    const userId = useState(initialState);

    const setUserId = (newValue) => userId.set(newValue);

    return {
        userId: userId.get(),
        setUserId,
        loggedIn: Boolean(userId.get()),
        authPending: userId.get() === null,
    };
};

export default useAuth;
